<template>
  <section class="sc-report-freight-cost">
    <sc-form
      :form="filter"
      @submit="generateFreightCostReport"
      :hasStyle="false">
      <template
        slot="fields"
        slot-scope="{ fields }">
        <sc-field label="Datas">
          <sc-range-date-picker
            v-model="fields.dateRange"
            :max-date="maxDate"
            :format="formatDateRange"
            class="sc-report-freight-cost__date-picker"/>
        </sc-field>

        <sc-field label="Tipo de Relatório">
          <sc-select
            class="sc-report-freight-cost__select"
            placeholder="Selecione"
            v-model="fields.report_type"
            expanded>
            <option
              v-for="(reportType, index) in reportTypesList"
              :key="index"
              :value="reportType.value">
              {{ reportType.label }}
            </option>
          </sc-select>
        </sc-field>

        <sc-field
          label="Peso Máximo"
          v-if="fields.report_type === 'weight'">
          <sc-decimal
            suffix=" Kg"
            v-model="fields.weight_ranges" />
        </sc-field>

        <sc-field label="Transportadoras">
          <sc-logistic-provider-dropdown
            v-model="fields.logistic_provider_id"
            :active="false"/>
        </sc-field>

        <sc-field
          label="Origem (CEP)"
          message='Use a tecla "vírgula" ou "enter" para incluir um CEP.'>
          <div class="field">
            <sc-taginput
              placeholder="12345-678"
              v-model="fields.origin_zip_codes"
              v-mask="'cep'" />
          </div>
        </sc-field>

        <sc-field label="Canal de Vendas">
          <sc-input
            placeholder="Canal de Vendas"
            v-model="fields.sales_channel" />
        </sc-field>

        <div class="sc-report-freight-cost__buttons">
          <button
            class="button is-primary sc-report-freight-cost__button"
            :class="{
              'is-loading': loading
            }"
            :disabled="!fields.report_type">
            Gerar relatório
          </button>

          <router-link
            v-if="hasGeneratedReport"
            class="button is-default sc-report-freight-cost__button"
            :to="{
              name: 'files-reports',
              params: {
                type: 'xlsx'
              }
            }">
            Ir para Meus arquivos
          </router-link>
        </div>
      </template>
    </sc-form>
  </section>
</template>

<script>
  import { Moment, Lodash } from '@intelipost-js/secure-providers';
  import {
    ScPageBase,
    ScField,
    ScInput,
    ScRangeDatePicker,
    ScIcon,
    ScSelect,
    ScTaginput,
    ScLogisticProviderDropdown,
    ScDecimal,
    ScForm,
  } from '@intelipost-js/secure-components';
  import { createNamespacedHelpers } from 'vuex';

  const { mapState, mapActions, mapMutations } = createNamespacedHelpers('analytic/freightCost');

  export default {
    data() {
      return {
        filter: Lodash.cloneDeep(this.$store.state.analytic.freightCost.filter),
        maxDate: Moment().toDate(),
        reportTypesList: [
          {
            label: 'Transportadora',
            value: 'logistic_provider',
          },
          {
            label: 'Estado',
            value: 'state',
          },
          {
            label: 'Peso',
            value: 'weight',
          },
        ],
      };
    },
    watch: {
      filter: {
        handler(filter) {
          this.setFilter(filter);
        },
        deep: true,
      },
    },
    computed: {
      ...mapState([
        'loading',
        'hasGeneratedReport',
        'deliveryMethodsList',
      ]),
    },
    methods: {
      ...mapActions([
        'generateFreightCostReport',
      ]),
      ...mapMutations([
        'setFilter',
      ]),
      formatDateRange(dateRange) {
        return {
          start: Moment(dateRange.start).format('YYYY-MM-DD'),
          end: Moment(dateRange.end).format('YYYY-MM-DD'),
        };
      },
    },
    components: {
      ScPageBase,
      ScField,
      ScInput,
      ScRangeDatePicker,
      ScIcon,
      ScSelect,
      ScTaginput,
      ScLogisticProviderDropdown,
      ScDecimal,
      ScForm,
    },
  };
</script>

<style lang="scss" scoped>
  .sc-report-freight-cost {
    margin-top: 45px;

    &__button {
      display: block;
      width: 100%;
      margin-right: 0;
      margin-bottom: 0.5rem;
    }

    &__tag {
      margin: 0.2rem;
    }
  }
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-analytic/features/reports/pages/freight-cost/ReportFreightCost.vue?8a42b69e